require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-react-pass-an-array-as-props.json") })
        }
      }, "path---front-end-libraries-react-pass-an-array-as-props");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-react-pass-an-array-as-props!./.cache/json/front-end-libraries-react-pass-an-array-as-props.json
// module id = 2077
// module chunks = 231608221292675